/**
 * Reversible cutover gate for normalized transcript storage.
 *
 * The same non-secret environment variable is consumed by the Next.js server,
 * browser Realtime hooks (through RuntimeConfig), and Python services. Default
 * OFF keeps a migration-first rollout and an immediate legacy rollback safe.
 */
export const TRANSCRIPT_NORMALIZED_STORAGE_ENV =
  'TRANSCRIPT_NORMALIZED_STORAGE_ENABLED' as const;

const ENABLED_VALUES = new Set(['1', 'true', 'yes', 'on']);

export function parseTranscriptNormalizedStorageFlag(value: unknown): boolean {
  return typeof value === 'string'
    && ENABLED_VALUES.has(value.trim().toLowerCase());
}

export function isTranscriptNormalizedStorageEnabled(): boolean {
  const runtimeValue = typeof window !== 'undefined'
    ? window.__RUNTIME_CONFIG__?.[TRANSCRIPT_NORMALIZED_STORAGE_ENV]
    : undefined;
  const value = runtimeValue ?? process.env.TRANSCRIPT_NORMALIZED_STORAGE_ENABLED;
  return parseTranscriptNormalizedStorageFlag(value);
}
